// extracted by mini-css-extract-plugin
export default {"headerBackground":"AdminHeader_headerBackground__tmrWY","headerContainer":"AdminHeader_headerContainer__Q1xJ2","headerWrapper":"AdminHeader_headerWrapper__1VF1F"};